import React from "react";
import RegisterForm from "./Form";

const RegisterContainer = () => {
  return (
    <section className="grid__padding">
      <RegisterForm />
    </section>
  );
};

export default RegisterContainer;
